import { useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	onClick: () => void;
};

export const PinNewDocumentRow: FC<Props> = ({ onClick }) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();

	return (
		<ListRow
			showChevron
			onClick={onClick}
			icon={<Plus size={iconSize.md} color={palette.green[600]} />}
			iconBg={palette.green[50]}
			title={t(Resources.PortfolioDetail.Pin.Kind.document.newTitle)}
			subtitle={t(Resources.PortfolioDetail.Pin.Kind.document.newSubtitle)}
			isLast
		/>
	);
};
